module.exports = __webpack_public_path__ + "img/2_02.edbf5461.jpg";